import { render, staticRenderFns } from "./BlockType101.vue?vue&type=template&id=1ae3fb0f&scoped=true"
import script from "./BlockType101.vue?vue&type=script&lang=ts"
export * from "./BlockType101.vue?vue&type=script&lang=ts"
import style0 from "./BlockType101.vue?vue&type=style&index=0&id=1ae3fb0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3fb0f",
  null
  
)

export default component.exports